import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <section id={id} className={`py-8 md:py-12 px-4 md:px-8 ${className}`} data-id="element-251">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-252">
        {children}
      </motion.div>
    </section>;
}